/* global jwplayer */

/**
 * WordPress dependencies
 */
import { getContext, store } from '@wordpress/interactivity';

const { state: routerState } = store('core/router', {});

store('itp/jwplayer-playlist', {
  callbacks: {
    // WP 6.9's router disables any stylesheet not in the fetched HTML on
    // navigation, including ones JW Player injects at runtime. Re-enable them.
    restoreInjectedStyles() {
      void routerState.url;
      document.querySelectorAll('style, link[rel="stylesheet"]').forEach((el) => {
        if (el.sheet?.disabled) {
          el.sheet.disabled = false;
        }
      });
    },
  },
  actions: {
    /**
     * Update the Now Playing media with the user selected video.
     *
     * @param {Event} e The click event triggered by the user.
     */
    playMedia(e) {
      const context = getContext();

      const currentItem = e.currentTarget
        .closest('.wp-block-itp-video')
        .querySelector(`button[data-media-id="${context.selectedVideo}"]`);

      const selectedVideo = e.currentTarget.getAttribute('data-media-id');
      const index = e.currentTarget.getAttribute('data-index');

      if (selectedVideo) {
        context.selectedVideo = selectedVideo;

        jwplayer(context.playerId).playlistItem(index);

        currentItem.setAttribute('aria-current', 'false');
        currentItem.removeAttribute('disabled');
        e.currentTarget.setAttribute('aria-current', 'true');
        e.currentTarget.setAttribute('disabled', 'true');
      }
    },
  },
});
